import { SaleTagIcon } from "@/components/__shared__/SaleTagIcon/SaleTagIcon.tsx";
import classNames from "classnames/bind";
import styles from "./SaleTag.module.scss";

const cx = classNames.bind(styles);

type SaleTagProps = {
  isDior: boolean;
};

export const SaleTag = ({ isDior }: SaleTagProps) => {
  return (
    <span className={cx("saleTag")} data-testid="sale-tag">
      <SaleTagIcon type="stroke" isBlackOverride={isDior} />
    </span>
  );
};
